import { track, useTracking } from 'lib/analytics'
import { useNavigate } from 'react-router-dom-v5-compat'
import HolidayOrnamnet from 'shared/svg/holiday-ornament.svg'
import HolidayMenorah from 'shared/svg/holiday-menorah.svg'
import HolidayPresent from 'shared/svg/holiday-present.svg'
import {
  ButtonGroup,
  ButtonRect,
} from 'registry/modules/onboarding/components/OnboardingButtons/OnboardingButtons'
import Slide from '../slide/slide'
import { PATHS } from '../../pages/HolidayFlow/HolidayFlow'
import css from './HolidaySelector.styles.scss'

enum ListType {
  CHRISTMAS = 'christmas',
  HANUKKAH = 'hannukah',
  OTHER = 'other',
}

interface RegistryTypeData {
  type: ListType
  label: string
  icon: JSX.Element
}

const registryTypes: RegistryTypeData[] = [
  {
    type: ListType.CHRISTMAS,
    label: 'Christmas',
    icon: <HolidayOrnamnet />,
  },
  {
    type: ListType.HANUKKAH,
    label: 'Hanukkah',
    icon: <HolidayMenorah />,
  },
  {
    type: ListType.OTHER,
    label: 'Other',
    icon: <HolidayPresent />,
  },
]

const HolidaySelector = () => {
  const tracker = useTracking()
  const navigate = useNavigate()

  const handleOnClick = (type: ListType) => {
    tracker.trackEvent({
      event: track.listTypeClicked,
      eventLocation: track.EventLocation.REGISTRY_STARTER_PAGE,
      listType: 'holiday',
      event_type: type,
    })

    switch (type) {
      case ListType.CHRISTMAS:
        navigate(PATHS.HOLIDAY_CELEBRATE_CHRISTMAS)
        break
      case ListType.HANUKKAH:
        navigate(PATHS.HOLIDAY_CELEBRATE_HANUKKAH)
        break
      default:
        navigate(PATHS.HOLIDAY_SELECT_OTHER)
        break
    }
  }

  return (
    <div className={css.HolidaySelector__container}>
      <Slide
        className={css.HolidaySelector__slide}
        title="What are you celebrating?"
      >
        <ButtonGroup>
          {registryTypes.map((registry) => (
            <ButtonRect
              className={css.HolidaySelector__button}
              key={registry.type}
              onClick={() => handleOnClick(registry.type)}
            >
              {registry.icon}
              <div className="h3 mtm mbn">{registry.label}</div>
            </ButtonRect>
          ))}
        </ButtonGroup>
      </Slide>
    </div>
  )
}

export default HolidaySelector
